<script>
    import { beforeUpdate } from "svelte";
    import { getImgSrcOfImg } from "../helper/ImgHelper";
    import LazyImage from "./LazyImage.svelte";

    export let img;

    let imgPath;
    let minSrc;

    beforeUpdate(() => {
        imgPath = getImgSrcOfImg(img,false);
        minSrc = getImgSrcOfImg(img,true);
    });
</script>

<div
    class="glass bg-bili-main shadow-lg rounded-lg w-full flex flex-wrap p-2 sm:p-4">
    <LazyImage classes="shadow-lg w-80 rounded-lg mx-auto self-center" src={imgPath} placeholder={minSrc}></LazyImage>
</div>
